import { z } from 'zod'
import { OptionalTextSchema } from '../shared/text'

// GET /pages/home. Os banners vêm do CMS; os posts vêm do blog (URL fixa https://blog.glofi.com.br/api, chamada pela
// API com cache de um dia). A API não devolve `bestSellers`: a vitrine da home é do catálogo
// (product/get-by-list-group/{id}).

/** Banner principal (carrossel). A API já troca imagem e URL ausentes por texto vazio. */
export const HomeBannerSchema = z.object({
    imageDesktop: z.string(),
    imageMobile: z.string(),
    urlDesktop: OptionalTextSchema,
    urlMobile: OptionalTextSchema,
    order: z.number(),
})

/** Post do blog (`BlogPostsResponse`: Url e Title são `string?`). */
export const BlogPostSchema = z.object({
    id: z.number(),
    url: OptionalTextSchema,
    title: OptionalTextSchema,
    category: OptionalTextSchema,
    thumbnail: OptionalTextSchema,
})

export const HomeResponseSchema = z.object({
    bannersPrimary: z.array(HomeBannerSchema),
    /** HTML dos banners secundários (`banner.Content`, pode ser nulo). */
    bannersSecondary: z.array(z.string().nullable()),
    /** HTML dos selos da home (`banner.Content`, pode ser nulo). */
    bannersBadgesSection: z.array(z.string().nullable()),
    blogPosts: z.array(BlogPostSchema),
})

export type IHomeBanner = z.infer<typeof HomeBannerSchema>
export type IBlogPost = z.infer<typeof BlogPostSchema>
export type IHomeResponse = z.infer<typeof HomeResponseSchema>
